
import { useState, useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText, Typography } from '@mui/material';
import './purpleairWebpage.css';
import imgBilliardsNE from './assets/monitorBilliardsNE.jpg';
import imgH2OMarine from './assets/monitorH20Marine.jpg';
import imgCocoanut from './assets/cocoanutMonitor.png';

import postData from './postData';

const PurpleairWebpageSensor = () => {
    const [retryCount, setRetryCount] = useState(0);

    //warning dialog variables
    const [openWarningDialog, setOpenWarningDialog] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [timeBilliardsNE, setTimeBilliardsNE] = useState(0);
    const [timeH2oMarine, setTimeH2oMarine] = useState(0);
    const [timeCocoanut, setTimeCocoanut] = useState(0);
    //-------------------------------------------------------------
    const formatDate = (thedate) => {
        return new Intl.DateTimeFormat('en-US', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
        }).format(thedate);
    };
    //-------------------------------------------------------------
    const sensorStatusLabel = (thedate) => {
        const diffInMs = new Date() - thedate; // difference in milliseconds
        let numMin = Math.round(diffInMs / (1000 * 60)); // convert ms to minute
        if (numMin < 5) {
            return 'Active'
        } else {
            if (numMin < 10) {
                return 'Delayed'
            } else {
                return 'Offline'
            }
        }
    }

    //-------------------------------------------------------------
    const sensorStatusColor = (thedate) => {
        const diffInMs = new Date() - thedate; // difference in milliseconds
        let numMin = Math.round(diffInMs / (1000 * 60)); // convert ms to minute
        if (numMin < 5) {
            return 'green'
        } else {
            if (numMin < 10) {
                return 'orange'
            } else {
                return 'red'
            }
        }
    }

    //-------------------------------------------------------------



    //-------------------------------------------------------------  
    // retrieve relevant submissions ------------------------------
    const getStatus = async () => {

        const formData = new FormData();
        var objEntity = await postData('https://sarasotapublic.com/usrecycling/purpleairWebpageSensorStatus.php', formData);
        setErrorMessage(objEntity.theError);
        if (objEntity.theData !== null) {
            for (let index = 0; index < objEntity.theData.length; index++) {
                switch (objEntity.theData[index].sensorname) {
                    case 'Billiards NE Corner':
                        break;
                    case 'Billiards NE2':
                        setTimeBilliardsNE(new Date(objEntity.theData[index].latest))
                        break;
                    case 'H2O Marine':
                        setTimeH2oMarine(new Date(objEntity.theData[index].latest))
                        break;
                    case 'MHI#2 - Cocoanut':
                        setTimeCocoanut(new Date(objEntity.theData[index].latest))
                        break;
                    default:
                        setErrorMessage(`unsupported sensor name:${objEntity.theData[index].sensorname}`);
                        break
                }
            }
        } else {
            if (retryCount < 3) {
                // Retry after 3 seconds
                setTimeout(() => setRetryCount(retryCount + 1), 3000);
            } //retry
        } //else 
    }

    useEffect(() => {
        getStatus();
        // eslint-disable-next-line
    }, [retryCount]);

    //-------------------------------------------------------------
    // ----- handle user warning
    useEffect(() => {
        if (errorMessage !== '') {
            setOpenWarningDialog(true);
        }
    }, [errorMessage]
    )
    const handleErrorDialogOK = () => {
        setOpenWarningDialog(false);
        setErrorMessage('');
    };



    return (
        <>{timeBilliardsNE < 1000 ? (<div>Loading...</div>) : (
            <>
                <div style={{ display: 'flex', height: '45vh', background: '#F0F0F0', gap: '20px', padding: '10px', justifyContent: 'center' }}>
                    <div className='columnBox'>
                        <Typography variant='h4' style={{ marginBottom: '5px' }}>Billiards NE2</Typography>
                        <img src={imgBilliardsNE} style={{ width: '20vw' }} alt='new monitor at northeast corner of Richards Billiards' />
                        <Typography variant='h5' style={{ color: sensorStatusColor(timeBilliardsNE) }}>
                            {sensorStatusLabel(timeBilliardsNE)} </Typography>
                        latest reading:<br />
                        {formatDate(timeBilliardsNE)}&nbsp;&nbsp;<br />
                    </div>
                    <div className='columnBox'>
                    <Typography variant='h4' style={{marginBottom:'5px'}}>H2O Marine</Typography>
                    <img src={imgH2OMarine} style={{ width: '20vw' }} alt='monitor at H2O Marine' />
                        <Typography variant='h5' style={{ color: sensorStatusColor(timeH2oMarine) }}>
                            {sensorStatusLabel(timeH2oMarine)} </Typography>
                        latest reading:<br />
                        {formatDate(timeH2oMarine)}
                    </div>
                </div>
                <div style={{ display: 'flex', height: '55vh', background: '#F0F0F0', gap: '20px', padding: '10px', justifyContent: 'center' }}>
                    <div className='columnBox'>
                        <Typography variant='h4' style={{ marginBottom: '5px' }}>Cocoanut</Typography>
                        <img src={imgCocoanut} style={{ width: '20vw' }} alt='monitor at MHI in Central Cocoanut' />
                        <Typography variant='h5' style={{ color: sensorStatusColor(timeCocoanut) }}>
                            {sensorStatusLabel(timeCocoanut)} </Typography>
                        latest reading:<br /> 
                        {formatDate(timeCocoanut)}&nbsp;&nbsp;<br />
                    </div>
                    <div className='columnBox'>
                    </div>
                </div>
            </>
        )}
            <Dialog
                open={openWarningDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Submission List Error
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {errorMessage}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleErrorDialogOK}>Ok</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default PurpleairWebpageSensor;